import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';
import { colors, pixelCalc } from '@prisjakt/ui-base/styles/variables';

import Button from '@prisjakt/ui-button';

export const Banner = styled.div`
  display: flex;
  align-items: center;
  border-radius: 10px;
  padding: 20px;
  background: #3b7994;
  background: radial-gradient(ellipse at center, #3b7994 0%, #2a5f76 100%);

  ${media.smallOnly`
    flex-direction: column;
    align-items: center;
  `};

  ${media.mediumUp`
    flex-direction: row;
    align-items: center;
  `};
`;

export const Badge = styled.div`
  ${media.smallOnly`
    img {
      max-width: 120px;
    }
  `};

  ${media.mediumUp`
    img {
      min-width: 200px;
    }
  `};
`;

export const Header = styled.div`
  h2 {
    color: ${colors.white};
    text-transform: uppercase;
    text-align: center;
  }

  ${media.smallOnly`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 10px;
  `};

  h2 {
    ${media.smallOnly`
      font-size: ${pixelCalc(2)}px;
    `};

    ${media.mediumUp`
      font-size: ${pixelCalc(4)}px;
    `};
  }
`;

export const Content = styled.div`
  text-align: center;

  p {
    color: ${colors.white};
  }
`;

export const Link = styled(Button).attrs({
  color: 'primary',
  variant: 'outlined',
})`
  /* Double selector needed to override hover color */
  && {
    color: ${colors.white};
    border-color: ${colors.white};
  }
`;
